export function mapValue(value, domain, range) {
  const newValue =
    ((value - domain[0]) * (range[1] - range[0])) / (domain[1] - domain[0]) + range[0]
  return Math.min(Math.max(newValue, range[0]), range[1])
}
